import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import { THEME_COLOR } from "../../../../styles/colors";

const PRIORITY_COLORS = {
  high: "error",
  medium: "warning",
  low: "success",
};

const ActionList = ({ title, items }) => {
  return (
    <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.MIST_GRAY, boxBorderRadiusOutline: 12 }}>
      <Box type="outline" spacingInset="400">
        <Column spacing="300">
          {title && (
            <Text type="h100">{title}</Text>
          )}
          {Array.isArray(items) && items.map((item, i) => (
            <Row key={i} spacing="200" alignmentVertical="center">
              <Text type="b200" color={PRIORITY_COLORS[item.priority] || "secondary"}>●</Text>
              <Text type="b200" color="secondary">{item.text}</Text>
            </Row>
          ))}
        </Column>
      </Box>
    </Theme>
  );
};

export default ActionList;
